export default "__VITE_ASSET__CFXaaQ92__"